import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EventsService} from "../../services/events.service";
import {CartService} from "../../services/cart.service";
import {UserService} from "../../services/user.service";
import {Product} from "../../model/product";

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {
  @ViewChild('content', {static: false}) delCartModal: NgbModal | undefined;

  showLoader = false;
  reLogin = false;

  shoppingCart: Product[] = [];
  validRequest: { type: string, message: string } = {type: '', message: ''};

  constructor(
      private events: EventsService,
      private modalService: NgbModal,
      private cartService: CartService,
      private userService: UserService
  ) {
  }

  ngOnInit() {
    this.shoppingCart = this.cartService.getCart();
    this.events.subscribe('user:logout', () => {
      this.cartService.reset();
    });
  }

  async removeCartEntry(entryId: string) {
    let valueJSON: Product;
    this.showLoader = true;
    let orderId;
    this.shoppingCart = this.cartService.getCart();
    try {
      const shoppingBasket = await this.cartService.getShoppingBasket() as any;

      this.showLoader = false;
      shoppingBasket.positionlist.forEach((val: any) => {
        if (val.product.productparameters.length > 0) {
          const parameters = val.product.productparameters.find((entry: any) => entry.id === 'FE-Auftrag');
          if (parameters) {
            valueJSON = JSON.parse(parameters.value.replace(/\\"/g, '\''));
            if (entryId === valueJSON.orderId) {
              orderId = val.id;
            }
          }
        }
      });
      if (orderId) {
        try {
          await this.cartService.deleteShoppingPosition(orderId);
          let tmpIndex = -1;
          this.shoppingCart.forEach((item, index) => {
            if (item.orderId === entryId) {
              tmpIndex = index;
              return;
            }
          });
          if (tmpIndex !== -1) {
            this.shoppingCart.splice(tmpIndex, 1);
            this.cartService.setCart(this.shoppingCart);
          }
        } catch (e) {
          this.showLoader = false;
          this.validRequest.type = 'error';
          this.validRequest.message = 'Der Eintrag konnte nicht gelöscht werden, es ist ein Fehler aufgetreten.';
        }
      }
    } catch (e) {
      this.showLoader = false;
      this.validRequest.type = 'error';
      this.validRequest.message = 'Der Eintrag konnte nicht gelöscht werden, es ist ein Fehler aufgetreten.';
    }
  }

  async removeCart() {
    this.showLoader = true;
    try {
      await this.userService.tokenIsValid();
      try {
        await this.cartService.deleteCart();
        this.showLoader = false;
        this.cartService.clearCartItems();
        this.shoppingCart = this.cartService.getCart();
        this.modalService.dismissAll();
      } catch (e) {
        this.showLoader = false;
        this.modalService.dismissAll();
        this.validRequest.type = 'error';
        this.validRequest.message = 'Der Warenkorb konnte nicht gelöscht werden, es ist ein Fehler aufgetreten.';
      }
    } catch (e) {
      this.showLoader = false;
      this.reLogin = true;
    }
  }

  async sendCart() {
    this.showLoader = true;
    try {
      await this.userService.tokenIsValid();
      try {
        await this.cartService.doOrder();
        this.showLoader = false;
        this.validRequest.type = 'success';
        this.validRequest.message = 'Der Warenkorb wurde erfolgreich bestellt. Sie erhalten eine Bestätigungsmail.';
      } catch (e) {
        this.showLoader = false;
        this.validRequest.type = 'error';
        this.validRequest.message = 'Bei der Bestellung des Warenkorbes ist ein Fehler aufgetreten.';
      }
    } catch (e) {
      this.showLoader = false;
      this.reLogin = true;
    }
  }

  openModal(content: any) {
    this.modalService.open(content, {size: 'sm'});
  }
}
